import { useMutation } from '@tanstack/react-query';
import {
  PartnersPostError,
  PartnersPostParams,
  PartnersPostResponse,
} from '@/api/model/authentication/partners.ts';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { BASE_URL_LANG } from '@/api/utils.ts';

const usePartnersPost = () =>
  useMutation<
    AxiosResponse<PartnersPostResponse>,
    AxiosError<PartnersPostError>,
    PartnersPostParams
  >({
    mutationFn: ({ email, password, sec_token, sendLogin }) => {
      const body = new FormData();
      body.append('sendLogin', sendLogin);
      body.append('email', email);
      body.append('password', password);
      body.append('sec_token', sec_token);

      return axios.post(`${BASE_URL_LANG}partners`, body, {
        headers: {
          'Content-Type': 'multipart/form-data',
          // Backend requires this header
          internal: 1,
        },
      });
    },
  });

export { usePartnersPost };
